import React, { useEffect, useRef } from "react"
import styled from "styled-components"
import colors from "assets/styles/colors"
import text from "assets/styles/text"
import media from "assets/styles/media"
import gsap from "gsap"
import { useMedia } from "utils/hooks"
import BGGrid, { LineConfig } from "./BGGrid"

type props = {
  children: (JSX.Element | string)[]
  left: boolean
  outlined?: boolean
  target?: string
}

const Banner: React.FC<props> = ({ children, left, outlined, target }) => {
  const speed = useMedia("4", "4", "6", "4")
  const text = useRef<HTMLHeadingElement>(null)
  const banner = useRef<HTMLDivElement>(null)
  const lineConfig: LineConfig = {
    sectionHeight: "100%",
    animationClass: "banner",
    behind: true,
  }




  useEffect(() => {
    if (text.current && banner.current) {
      const tl = gsap.timeline({
        scrollTrigger: {
          scroller: window,
          trigger: banner.current,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      })

      tl.to(text.current, { x: "-100vw", duration: 10 }, 0)
    }
  }, [])

  return (
    <Wrapper ref={banner}>
      <BGGrid lineConfig={lineConfig}/>
      <SidewaysText $left={left} data-scroll>
        <DigText
          data-scroll-direction="horizontal"
          data-scroll-target={target || `#RRE_Banner`}
          data-scroll
          data-scroll-speed={speed}
          ref={text}
        >
          <>
            {children}
            {children}
          </>
        </DigText>
      </SidewaysText>
    </Wrapper>
  )
}

export default Banner

const Wrapper = styled.div`
  width: 100%;
  padding: 30px;
  bottom: 0;
  left: 0;
  display: inline-block;
  background: ${colors.white};
  z-index: 0;
  will-change: transform;

  ${media.tablet} {
    height: 19.53vw;
  }

  ${media.mobile} {
    height: 42.67vw;
  }
`

const SidewaysText = styled.div<{ $left: boolean }>`
  position: relative;
  left: -20%;
  height: 100%;
  width: 1000vw;
  display: flex;

  ${media.tablet} {
    height: 100%;
    top: 0;
  }
  ${media.mobile} {
    height: 100%;
  }
`

const DigText = styled.h1`
  ${text.desktop.bannerText};
  color: ${colors.blue400};
  white-space: pre;
  height: 100%;
  padding: 0;

  display: flex;
  align-items: center;
  ${media.tablet} {
    font-family: Neue Montreal;
    font-style: normal;
    font-weight: normal;
    font-size: 14.61vw;
    line-height: 95%;
    /* or 142px */

    letter-spacing: -0.03em;
  }
  ${media.mobile} {
    font-family: Neue Montreal;
    font-style: normal;
    font-weight: normal;
    font-size: 26.67vw;
    line-height: 95%;
    /* or 95px */

    letter-spacing: -0.03em;
  }
`
